import { useState, useEffect, useRef } from 'react';

export const usePagination = (splitArray, filterInputs = {}, sortProducts = '') => {
  const prevFilterKeyRef = useRef('');

  // Create a unique key based on current filters
  const getFilterKey = () => {
    // Check if any filter is active
    const hasActiveFilters =
      Object.values(filterInputs).some(
        (val) => val !== '' && val !== null && val !== undefined,
      ) || sortProducts !== '';

    if (!hasActiveFilters) {
      return 'no_filters'; // Special key for no filters
    }

    // Create a signature of current filters
    return JSON.stringify({
      ...filterInputs,
      sort: sortProducts,
    });
  };

  const currentFilterKey = getFilterKey();
  const storageKey = `pagination_${currentFilterKey}`;

  // Initialize state
  const [currentPage, setCurrentPage] = useState(() => {
    // Always page 1 when no filters
    if (currentFilterKey === 'no_filters') {
      return 1;
    }

    // Load saved page or default to 1
    const savedPage = localStorage.getItem(storageKey);
    return savedPage ? parseInt(savedPage) : 1;
  });

  // EFFECT 1: Reset to page 1 whenever filters change
  useEffect(() => {
    // Skip initial mount
    if (prevFilterKeyRef.current === '') {
      prevFilterKeyRef.current = currentFilterKey;
      return;
    }

    // If filters changed, reset to page 1
    if (prevFilterKeyRef.current !== currentFilterKey) {
      console.log(
        'Filters changed from',
        prevFilterKeyRef.current,
        'to',
        currentFilterKey,
        '- resetting to page 1',
      );
      setCurrentPage(1);
    }

    prevFilterKeyRef.current = currentFilterKey;
  }, [currentFilterKey]);

  // EFFECT 2: Save current page to localStorage when it changes
  useEffect(() => {
    if (currentFilterKey !== 'no_filters') {
      localStorage.setItem(storageKey, currentPage.toString());
    }
  }, [currentPage, currentFilterKey, storageKey]);

  // EFFECT 3: Reset to page 1 if current page exceeds available pages
  useEffect(() => {
    if (splitArray && currentPage > splitArray.length && splitArray.length > 0) {
      setCurrentPage(1);
      if (currentFilterKey !== 'no_filters') {
        localStorage.setItem(storageKey, '1');
      }
    }
  }, [splitArray, currentPage, currentFilterKey, storageKey]);

  const countHandler = (e) => {
    const idx = e.target.selectedIndex;
    const el = e.target.childNodes[idx];
    setCurrentPage(+el.value);
  };

  return { currentPage, setCurrentPage, countHandler };
};
